export const environment = {
  env: 'dev',
  production: true,
  host: 'https://dev.dicomhub.cn',
  api: '/portal/api/v1/portal',
  openAPI: '/portal/open/api/v1',
};
